declare const angular, document;
export class productInfoFooterController {
    warrantyDetail: string;
    constructor(private $mdDialog, private $vendorInfo, private MyConstant) {
        "ngInject"

    }

    showVendorInfo(ev, type) {

        this.$mdDialog.show({
            controller: function ($mdDialog, $vendorInfo, $state, $filter, $mdMedia) {
                this.type = type
                this.$mdMedia = $mdMedia;
                switch (type) {
                    case 'payment':
                        this.title = 'شرایط پرداخت فروشگاه'
                        $vendorInfo.payment({ productId: $state.params.pID },
                            response => {
                                response.map(item => {
                                    item.Title = $filter('translates')(item.PaymentMethodName, "FA");
                                })
                                this.items = response
                            }
                        )
                        break;
                    case 'shippment':
                        this.title = 'شرایط حمل فروشگاه'
                        $vendorInfo.shippment({ productId: $state.params.pID },
                            response => {
                                response.map(item => {
                                    item.Title = item.TransportTypeName
                                    item.subTitle = `مدت زمان ارسال :‌${item.DelayHours}`
                                })
                                this.items = response
                            }
                        )
                        break;
                    case 'warranty':
                        this.title = 'شرایط ضمانت فروشگاه'
                        $vendorInfo.warranty({ productId: $state.params.pID },
                            response => {
                                response.map(item => {
                                    item.subTitle = `تعداد ماه گارانتی :‌${item.WarantyMonth}`
                                })
                                this.items = response
                            }
                        )
                        break;
                }
                this.cancel = () => {
                    $mdDialog.hide()
                }
            },
            controllerAs: 'dialog',
            template: `<md-dialog ng-class="{'md-dialog-fullscreen':dialog.$mdMedia('max-width: 600px')}" class="vendor-more-info" aria-label="" flex="70">
	<md-toolbar>
		<div class="md-toolbar-tools">
			<h2>{{dialog.title}}</h2>
			<span flex></span>
			<md-button class="md-icon-button" ng-click="dialog.cancel()">
				<md-icon class="zmdi zmdi-close" aria-label="Close dialog"></md-icon>
			</md-button>
		</div>
	</md-toolbar>

	<md-dialog-content>
		<spn-loading ng-if="!dialog.items"></spn-loading>
		<div class="md-dialog-content">
			<md-card ng-repeat="item in dialog.items">
				<md-card-header class="md-primary">
					<md-card-avatar>
						<md-icon class="md-avatar-icon zmdi" ng-class="{'zmdi-truck':dialog.type=='shippment','zmdi-card':dialog.type == 'payment','zmdi-swap':dialog.type=='warranty'}"></md-icon>
					</md-card-avatar>
					<md-card-header-text>
						<span class="md-title" ng-class="{'single-title':dialog.type=='payment'}">{{::item.Title}}</span>
						<span ng-show="item.subTitle" class="md-subhead">{{::item.subTitle}}</span>
					</md-card-header-text>
				</md-card-header>
				<md-card-content>
					<p>
						{{::item.Description}}
					</p>
				</md-card-content>
			</md-card>
			<div class="no-exist card-panel" ng-if="dialog.items.length == 0">
				موردی یافت نشد.
			</div>
		</div>
	</md-dialog-content>

</md-dialog>`,
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: true,
        })
    }
}




// WEBPACK FOOTER //
// ./src/components/product-info-footer/product-info-footer.controller.ts